<template>
  <dashboard-section :bordered="$device.isMobileOrTablet">
    <div slot="header" class="d-flex ai-center">
      <span class="d-flex ai-center text-lg text-bold" selenium="job-details-job-label">
        Job Details
      </span>
      <span class="JOB-ID-BUBBLE" selenium="job-details-job-id">Job ID
        {{ job.user_friendly_identifier }}</span>
    </div>
    <masonry-columns class="m-t-1">
      <masonry-columns-cell :bordered="$device.isMobileOrTablet">
        <h6 class="h6 text-semibold m-0" selenium="job-details-location-label">Location</h6>
        <p class="text-lg c-gray70 p-b-2 p-b-3:d" selenium="job-details-location">
          {{ job.location | location }}
        </p>
      </masonry-columns-cell>
      <masonry-columns-cell :bordered="$device.isMobileOrTablet">
        <h6 class="h6 text-semibold m-0" selenium="job-details-subtask-label">Service</h6>
        <p
            class="text-lg c-gray70 p-b-2 p-b-3:d"
            selenium="job-details-subtask">{{ job.service_name }}</p>
      </masonry-columns-cell>
      <masonry-columns-cell
          :bordered="$device.isMobileOrTablet"
          v-for="(lqq, index) in job.qualifying_qas"
          :key="lqq.short_question"
          :selenium="`job-details-lqq:${index}`">
        <h6
            class="h6 text-semibold m-0"
            selenium="job-details-lqq-label">{{ lqq.short_question }}</h6>
        <p
            class="text-lg c-gray70 p-b-2 p-b-3:d"
            selenium="job-details-lqq-answer">{{ lqq.answer }}</p>
      </masonry-columns-cell>
      <masonry-columns-cell :bordered="$device.isMobileOrTablet">
        <h6
            class="h6 text-semibold m-0"
            selenium="job-details-urgency-label">
          Customer Timeframe
        </h6>
        <div class="d-flex fd-column p-b-2 p-b-3:d">
          <p class="text-lg c-gray70" selenium="job-details-urgency">{{ timeframe }}</p>
          <span
              class="text-md DARK-TEXT"
              selenium="job-details-urgency-received">
            Received {{ new Date(match.time_created) | timeReceivedJobs }}
          </span>
        </div>
      </masonry-columns-cell>
      <masonry-columns-cell :bordered="$device.isMobileOrTablet">
        <h6
            class="h6 text-semibold m-0"
            selenium="job-details-customer-notes-label">Customer notes</h6>
        <p
            class="text-lg c-gray70 p-b-2 p-b-3:d WRAP-TEXT"
            selenium="job-details-customer-notes"
        >
          <span v-if="this.job.merchant_order_lines.length">
            <notes-with-url
                :merchantOrderLines= "this.job.merchant_order_lines"
                :description= "this.job.description"/>
          </span>
          <span v-else>{{ jobNotes }}</span>
        </p>
      </masonry-columns-cell>
      <masonry-columns-cell selenium="job-details-photos" :bordered="$device.isMobileOrTablet">
        <h6
            v-if="$device.isMobileOrTablet"
            class="h6 text-semibold m-0"
            :class="{ 'm-b-1': hasImages }"
            selenium="label">
          Photos From Customer
        </h6>
        <h6
            v-else
            class="h6 text-semibold m-0"
            :class="{ 'm-b-1': hasImages }"
            selenium="label">
          Customer Photos
        </h6>
        <gallery v-if="job.attachments.length" :files="job.attachments" class="p-b-2" />
        <div
            v-else
            class="text-lg c-gray70 p-b-2 p-b-3:d"
            selenium="job-details-no-photos">
          <span >
            No customer pictures provided.
          </span>

        </div>
      </masonry-columns-cell>
      <masonry-columns-cell :bordered="$device.isMobileOrTablet">
        <h6 class="h6 text-semibold m-0" selenium="job-details-lead-cost-label">Lead cost</h6>
        <p
            v-if= match.lead_cost
            class="text-lg p-b-2 c-gray70"
            selenium="job-details-lead-cost">
          {{ `${match.lead_cost} points` }}
        </p>
        <p
            v-else
            class="text-lg p-b-2 c-gray70"
            selenium="job-details-lead-cost">
          0 points
        </p>
      </masonry-columns-cell>
      <masonry-columns-cell v-if="isCompleted" selenium="job-details-photos" :bordered="$device.isMobileOrTablet" class="d-none:mo">
        <h6
            class="h6 text-semibold m-0"
            selenium="label">
          My Project Photos
        </h6>
        <p
            class="text-lg c-gray70 p-b-2"
        >Boost your profile by sharing photos on your profile.</p>
        <span  class="d-flex ai-center link">
          <vk-icon
              name="camera"
              class="m-r-1"
              size="20"/>
          <span @click="gotoAddPhoto" class="link">Add Project Photos</span>
        </span>

      </masonry-columns-cell>
    </masonry-columns>
  </dashboard-section>
</template>

<script>
import { mapGetters } from 'vuex';
import jobParams from '@/mixins/job-params';
import job from '@/mixins/job';
import subtask from '@/mixins/job/subtask';
// import files from '@/mixins/job/files';
import DashboardSection from '@/views/Dashboard/components/DashboardSection';
import MasonryColumns from '@/views/Dashboard/components/MasonryColumns';
import MasonryColumnsCell from '@/views/Dashboard/components/MasonryColumns/MasonryColumnsCell';
import NotesWithUrl from '@/components/NotesWithUrl';

export default {
  name: 'job-details',
  components: {
    DashboardSection,
    MasonryColumns,
    MasonryColumnsCell,
    NotesWithUrl,
  },
  mixins: [
    jobParams,
    job,
    subtask,
    // files,
  ],
  computed: {
    ...mapGetters('account/pro', { occupations: 'serviceProviderCatalogOccupations' }),
    // Used by subtask mixin.
    subtaskId () {
      return this.job.subtask;
    },
    timeframe () {
      return this.urgency;
    },
    hasImages () {
      return this.job.attachments.length;
    },
    jobNotes () {
      return this.job.description || '(not provided)';
    },
    isCompleted () {
      return this.match.status === jobParams.MATCH_STATUSES.COMPLETED;
    },
    occupationId () {
      const matchingOccupation = Object.keys(this.occupations)
        .find(
          key => this.occupations[key].occupation_id === this.match.occupation_id
        );
      return matchingOccupation;
    },
  },
  methods: {
    gotoAddPhoto () {
      this.$router.replace({
        name: 'account::pro::occupation',
        params: {
          serviceProviderOccupationId: this.occupationId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .JOB-ID-BUBBLE {
    @include text-medium;
    margin-left: 2*$unit;
    padding: 0 $unit;
    color: #808286;
    background-color: $color-gray20;
  }
  .WRAP-TEXT {
    word-break: break-word;
    white-space: normal;
  }
  .DARK-TEXT {
    color: #808286;
  }
</style>
